const options = {
  5: "bg-emerald-800/5",
  10: "bg-emerald-800/10",
  25: "bg-emerald-800/25",
  50: "bg-emerald-800/50",
  75: "bg-emerald-800/75",
  90: "bg-emerald-800/90",
  100: "bg-emerald-800",
};

const from = {
  5: "from-emerald-800/5",
  10: "from-emerald-800/10",
  25: "from-emerald-800/25",
  50: "from-emerald-800/50",
  75: "from-emerald-800/75",
  90: "from-emerald-800/90",
  100: "from-emerald-800",
};

export default function getBackgroundEmerald800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
